import { render, staticRenderFns } from "./ExamQuestion.vue?vue&type=template&id=31bb57a6&scoped=true"
import script from "./ExamQuestion.vue?vue&type=script&lang=js"
export * from "./ExamQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb57a6",
  null
  
)

export default component.exports